import { getAllSheetsFromXLS } from '../../utils/getAllSheetsFromXLS';

export function tgaParseTA(blob) {
  const sheets = getAllSheetsFromXLS(blob);

  return {
    meta: getMeta(sheets),
    variables: getVariables(sheets),
  };
}

function getMeta(sheets) {
  const sheet = sheets.find((sheet) => sheet.sheetName === 'Details');
  if (!sheet) {
    return {};
  }
  const meta = {};
  for (let datum of sheet.data) {
    meta[datum[0]] = datum[1];
  }
  return meta;
}

function getVariables(sheets) {
  sheets = sheets.filter((sheet) => sheet.sheetName !== 'Details');

  const variables = {
    t: {
      symbol: 't',
      label: 'Time',
      units: 'min',
      data: [],
    },
    x: {
      symbol: 'x',
      label: 'Temperature',
      units: '°C',
      data: [],
    },
    w: {
      symbol: 'w',
      label: 'Weight',
      units: 'mg',
      data: [],
    },
    y: {
      symbol: 'y',
      label: 'Weight',
      units: '%',
      data: [],
    },
  };

  for (let sheet of sheets) {
    const parsed = parseDataSheet(sheet);
    checkVariables(parsed, variables);

    variables.t.data = variables.t.data.concat(parsed[0].data);
    variables.x.data = variables.x.data.concat(parsed[1].data);
    variables.w.data = variables.w.data.concat(parsed[2].data);
    variables.y.data = variables.y.data.concat(parsed[3].data);
  }
  return variables;
}

function parseDataSheet(sheet) {
  const data = sheet.data.slice(1);
  const variableNames = data.shift();
  const variableUnits = data.shift();
  const variables = [];
  for (let i = 0; i < variableNames.length; i++) {
    variables.push({
      label: variableNames[i],
      units: variableUnits[i],
      data: [],
    });
    for (let j = 0; j < data.length; j++) {
      variables[i].data.push(data[j][i]);
    }
  }
  return variables;
}

function checkVariables(parsed, variables) {
  for (let i = 0; i < parsed.length; i++) {
    const targetVariable = variables[Object.keys(variables)[i]];
    if (!targetVariable) {
      continue;
    }
    if (
      parsed[i].label !== targetVariable.label ||
      parsed[i].units !== targetVariable.units
    ) {
      throw new Error(
        `Column ${i} is not ${targetVariable.label} in ${targetVariable.units}`,
      );
    }
  }
}
